module.exports = __webpack_public_path__ + "img/278.f4fee2af.jpg";